

/**
 * @name PaymentController
 * @description Controller for payments
 * @param {unknown} $scope Description
 * @param {unknown} $http Description
 * @param {unknown} stripe Description
 * @param {unknown} ENDPOINT Description
 * @param {unknown} $log Description
 * @param {library} _ The Lodash library
 */
function PaymentController(
  $scope,
  $http,
  stripe,
  ENDPOINT,
  $log,
  _
) {
  let vm = this;

  // Get card token
  vm.charge = function() {
    return stripe.card.createToken($scope.card)
      .then(function(response) {
        $log.debug('token created for card ending in ', response.card.last4);
        let payment = _.cloneDeep($scope.card);
        payment.card = null;
        payment.token = response.id;
        $log.debug(payment.token);
        return $http.post(ENDPOINT.server + 'payments/api/v1.1/pay/');
      })
      .then(function(payment) {
        $log.debug('successfully submitted payment for $', payment.amount);
      })
      .catch(function(err) {
        if (err.type && /^Stripe/.test(err.type)) {
          $log.debug('Stripe error: ', err.message);
        } else {
          $log.debug('Other error occurred, possibly with your API', err.message);
        }
      });
  };
}

angular
  .module('inkfinder')
  .controller('PaymentController', PaymentController);



// WEBPACK FOOTER //
// ./components/account-payments/payments.controller.js